import React from 'react';
import CONSTANTS from '../../../assets/constants';

const HowToComplete = () => (
  <div
    style={{
      backgroundImage: `url(${CONSTANTS.HOW_TO_COMPLETE_BACKGROUND})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    <div className="grid-container padding-horizontal-2">
      <div className="grid-x grid-padding-x align-middle">
        <div className="cell small-12 medium-7">
          <div className="padding-vertical-3 margin-bottom-3">
            <h2 className="margin-bottom-2">
              <img
                className="padding-right-2"
                src={CONSTANTS.NOTEICON}
                alt="Note Icon"
              />
              {CONSTANTS.HOW_TO_COMPLETE}
            </h2>
            <p className="margin-bottom-2">{CONSTANTS.CHOICES_HEADING}</p>
            <ul className="margin-bottom-2">
              <li className="font-bold">{CONSTANTS.CHOICE1}</li>
              <li className="font-bold">{CONSTANTS.CHOICE2}</li>
              <li className="font-bold">{CONSTANTS.CHOICE3}</li>
            </ul>
            <p>{CONSTANTS.CHOICES_NOTE}</p>
          </div>
        </div>
        <div className="cell small-12 medium-5">
          <img
            src={CONSTANTS.KIDNEYS}
            alt="Kidneys"
            className="complete-kidneys"
          />
        </div>
      </div>
    </div>
  </div>
);

export default HowToComplete;
